export default "__VITE_ASSET__Cgmymia8__"